import { getWorkersCompReferralPolicy } from "@/configuration/workers-comp";
import { isReferralWorkersComp, type Referral } from "@/src/models/documents/referral";
import type { Group } from "@/src/models/group";
import type { WorkersCompReferralPolicy } from "@/src/models/workers-comp-referral";

/**
 * Group-gated rather than a bare flag check: other tenants extract `isWorkersComp` for their own
 * reasons (Confluent writes it onto a case) and must keep recommending comp referrals.
 */
function resolveWorkersCompPolicy(
  group: Group | null | undefined,
  referral: Pick<Referral, "section"> | null | undefined
): WorkersCompReferralPolicy | null {
  if (!group || !referral) return null;

  const policy = getWorkersCompReferralPolicy(group);

  return policy && isReferralWorkersComp(referral) ? policy : null;
}

export function isWorkersCompReferralExcludedFromScheduling(
  group: Group | null | undefined,
  referral: Pick<Referral, "section"> | null | undefined
): boolean {
  return resolveWorkersCompPolicy(group, referral) !== null;
}

/** The group's own copy to render in place of a bookable slot, or null when the referral is schedulable. */
export function resolveWorkersCompSchedulingNotice(
  group: Group | null | undefined,
  referral: Pick<Referral, "section"> | null | undefined
): string | null {
  return resolveWorkersCompPolicy(group, referral)?.schedulingNotice ?? null;
}
